export default "<fa-alert></fa-alert>\n";